module.exports = __webpack_public_path__ + "img/pvc_expomoda_shiny_0020_black_250x250.f3147f6f.jpg";